import { render } from "./ProductNavigationComponent.vue?vue&type=template&id=4380779d&scoped=true"
import script from "./ProductNavigationComponent.vue?vue&type=script&lang=js"
export * from "./ProductNavigationComponent.vue?vue&type=script&lang=js"

import "./ProductNavigationComponent.vue?vue&type=style&index=0&id=4380779d&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4380779d"]])

export default __exports__